import React from "react";
import "./Business.css";

const Business = () => {
  return (
    <div className="business_parent_div">
      <h1>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Suscipit illo
        minus tempora culpa odit quidem quae similique ea quibusdam nesciunt,
        eum quas fugit vero asperiores assumenda reprehenderit qui blanditiis
        voluptates.
      </h1>
    </div>
  );
};

export default Business;
